import React from "react";
import FitMatrix from "../FitMatrix";
import { RK, ReportList, ReportChips, ReportCallout } from "../reports/ReportKit";
import { Target, Building2 } from "lucide-react";

export default function OverviewTab({ problem, company, fit, analysisId }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8" data-testid="dashboard-grid">
      <div className="md:col-span-8 rm-card-static p-6 md:p-8" data-testid="problem-card">
        <div className="flex items-center gap-3 mb-3">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ background: "#FF6A00", color: "white", border: "3px solid #0F1B2D" }}
          >
            <Target size={20} strokeWidth={2.5} />
          </div>
          <div className="rm-label">The Real Problem</div>
        </div>
        <h2 className="font-display text-2xl md:text-3xl uppercase leading-tight mb-3">
          {problem.headline || "—"}
        </h2>
        <p className="text-base whitespace-pre-line" style={{ color: "#1F2937" }}>
          {problem.details || ""}
        </p>
        <ReportList title="Success looks like" color={RK.orange} items={problem.key_outcomes} className="mt-5 block" />
      </div>

      <div
        className="md:col-span-4 rm-card-static p-6 md:p-8"
        style={{ background: "#FFC145" }}
        data-testid="company-card"
      >
        <div className="flex items-center gap-3 mb-3">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ background: "#0F1B2D", color: "white", border: "3px solid #0F1B2D" }}
          >
            <Building2 size={20} strokeWidth={2.5} />
          </div>
          <div className="rm-label">Company &amp; Tone</div>
        </div>
        <h3 className="font-display text-2xl uppercase leading-tight">
          {company.name || "Unknown Co."}
        </h3>
        <div className="font-mono-rm text-xs uppercase tracking-widest mt-1">
          {company.tone || "—"}
        </div>
        <p className="text-sm mt-3">{company.culture_summary || ""}</p>
        <ReportChips items={company.values} tone="nice" className="mt-3 block" />
        {company.writing_style_tip && (
          <ReportCallout title="Resume voice" color={RK.navy} bg="white" border={RK.navy} className="mt-4">
            {company.writing_style_tip}
          </ReportCallout>
        )}
      </div>

      <div className="md:col-span-6 rm-card-static p-6 md:p-8" data-testid="fit-card">
        <div className="flex items-center gap-3 mb-4">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ background: "#0F1B2D", color: "white", border: "3px solid #0F1B2D" }}
          >
            <span className="font-display text-lg">%</span>
          </div>
          <div className="rm-label">Fit Matrix</div>
        </div>
        <FitMatrix
          matrix={fit.matrix || []}
          overall={fit.overall_score || 0}
          verdict={fit.verdict || ""}
          strengths={fit.strengths || []}
          gaps={fit.gaps || []}
          analysisId={analysisId}
        />
      </div>
    </div>
  );
}
